import React from "react";
import {
    Card,
    CardContent,
    Box,
    Typography,
    CardHeader,
    Alert,
} from "@mui/material";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import PORTAvatar from "./PORTAvatar";

function PORTErrorCard({ resource, title, error, message }) {
    return (
        <Card sx={{ width: "100%" }} className="card">
            <CardHeader
                avatar={<PORTAvatar type={resource} />}
                title={
                    <Typography variant="h3" className="card-header-title">
                        {title}
                    </Typography>
                }
                subheader={
                    <Typography
                        component="span"
                        className="card-header-subtitle"
                    >
                        {error}
                    </Typography>
                }
            />
            <CardContent>
                <Box className="card-content">
                    <Alert
                        severity="warning"
                        icon={<WarningAmberIcon fontSize="medium" />}
                    >
                        {message}
                    </Alert>
                </Box>
            </CardContent>
        </Card>
    );
}

export default PORTErrorCard;
